import { useEffect } from "react";

/**
 * Sets document.title, meta description, meta keywords, canonical, og:*, robots for a page.
 * Purely client-side, but Google (and most crawlers) render JS and pick these up.
 */
export default function useSEO({ title, description, keywords, path, noindex }) {
  useEffect(() => {
    if (title) document.title = title;

    const ensure = (selector, create) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };

    if (description) {
      const meta = ensure('meta[name="description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "description");
        return m;
      });
      meta.setAttribute("content", description);

      const og = ensure('meta[property="og:description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:description");
        return m;
      });
      og.setAttribute("content", description);

      const tw = ensure('meta[name="twitter:description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "twitter:description");
        return m;
      });
      tw.setAttribute("content", description);
    }

    if (title) {
      const og = ensure('meta[property="og:title"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:title");
        return m;
      });
      og.setAttribute("content", title);

      const tw = ensure('meta[name="twitter:title"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "twitter:title");
        return m;
      });
      tw.setAttribute("content", title);
    }

    if (keywords) {
      const meta = ensure('meta[name="keywords"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "keywords");
        return m;
      });
      meta.setAttribute("content", keywords);
    }

    if (path) {
      const url = `https://taeste.de${path}`;
      const canonical = ensure('link[rel="canonical"]', () => {
        const l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        return l;
      });
      canonical.setAttribute("href", url);

      const ogUrl = ensure('meta[property="og:url"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:url");
        return m;
      });
      ogUrl.setAttribute("content", url);
    }

    // Robots directive (per-page)
    const robots = ensure('meta[name="robots"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "robots");
      return m;
    });
    robots.setAttribute(
      "content",
      noindex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
    );
  }, [title, description, keywords, path, noindex]);
}
